const Copy = ({ styles }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7 1.6665H9.45487C7.98466 1.66649 6.82015 1.66648 5.90878 1.7895C4.97084 1.91611 4.21169 2.18287 3.613 2.78397C3.0143 3.38506 2.74861 4.14727 2.62251 5.08898C2.49998 6.00401 2.49999 7.17318 2.5 8.64929V13.5139C2.5 14.7707 3.26663 15.8477 4.35597 16.2992C4.2999 15.5413 4.29995 14.4779 4.3 13.5932L4.3 9.49783L4.3 9.41851C4.29994 8.35046 4.29989 7.4302 4.39857 6.69326C4.50433 5.90348 4.74282 5.14643 5.35442 4.53238C5.96601 3.91833 6.72003 3.67888 7.50665 3.5727C8.24064 3.47362 9.15722 3.47367 10.221 3.47373L10.3 3.47373H12.7L12.779 3.47373C13.8428 3.47367 14.7574 3.47362 15.4914 3.5727C15.0523 2.45633 13.968 1.6665 12.7 1.6665Z"
        fill="#00003A"
        {...styles}
      />
      <path
        d="M5.5 9.49799C5.5 7.22616 5.5 6.09024 6.20294 5.38448C6.90589 4.67871 8.03726 4.67871 10.3 4.67871H12.7C14.9627 4.67871 16.0941 4.67871 16.7971 5.38448C17.5 6.09024 17.5 7.22616 17.5 9.49799V13.5141C17.5 15.7859 17.5 16.9218 16.7971 17.6276C16.0941 18.3333 14.9627 18.3333 12.7 18.3333H10.3C8.03726 18.3333 6.90589 18.3333 6.20294 17.6276C5.5 16.9218 5.5 15.7859 5.5 13.5141V9.49799Z"
        fill="#00003A"
        {...styles}
      />
    </svg>
  )
}

export default Copy
